import { letterPickerAriaLabel } from './hubListGroupCell.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
/* tslint:disable:jsx-no-lambda WI:47586 */
import * as React from 'react';
import type { HubListGroupItem } from '../../hubListItem';
import { handleKey, safeRender } from '../../../..';

export interface Props {
    readonly group: HubListGroupItem;
    readonly element: JSX.Element;
    readonly isActive: boolean;
    readonly disableScrollToHubListGroupMenu: boolean;

    readonly onClick: (target: HTMLElement) => void;
    readonly onFocusDebounceHandler: (func: () => void) => void;
}

import styles from './hubListGroupCell.scss';

const HubListGroupCell = function HubListGroupCell(props: Props) {
    let calloutTarget: HTMLElement;
    const ariaProps = props.disableScrollToHubListGroupMenu
        ? {}
        : {
              'aria-label': loc(letterPickerAriaLabel),
              'aria-expanded': false,
              role: 'dialog',
          };

    return (
        <div
            {...ariaProps}
            className={styles.groupHeader}
            onFocus={() => props.onFocusDebounceHandler(() => {})}
            ref={element => (calloutTarget = element) && props.isActive && element.focus()}
            tabIndex={props.isActive ? 0 : -1}
            data-is-focusable={true}
            onKeyDown={handleKey({
                onSpace: () => props.onClick(calloutTarget),
                onEnter: () => props.onClick(calloutTarget),
            })}
            onClick={() => props.onClick(calloutTarget)}>
            {props.element}
        </div>
    );
};
export default observer(safeRender(HubListGroupCell, 'HubListGroupCell'));
